/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.6.2.0 (NJsonSchema v10.1.23.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { BaseClientApi, ClientApiConfig } from  '@eta/components';
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IContentManagementClient {
    /**
     * @param code (optional) 
     * @param lang (optional) 
     * @return Success
     */
    getContentByCode(code?: string | null | undefined, lang?: string | null | undefined): Promise<GetContentByCodeResponse>;
    /**
     * @param path (optional) 
     * @param lang (optional) 
     * @return Success
     */
    content(path?: string | null | undefined, lang?: string | null | undefined): Promise<string>;
}

export class ContentManagementClient extends BaseClientApi implements IContentManagementClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientApiConfig, baseUrl?: string, instance?: AxiosInstance) {
        super(configuration);
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : this.getBaseUrl("");
    }

    /**
     * @param code (optional) 
     * @param lang (optional) 
     * @return Success
     */
    getContentByCode(code?: string | null | undefined, lang?: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<GetContentByCodeResponse> {
        let url_ = this.baseUrl + "/api/v{version}/inlinecontent/view?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContentByCode(_response);
        });
    }

    protected processGetContentByCode(response: AxiosResponse): Promise<GetContentByCodeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetContentByCodeResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetContentByCodeResponse>(<any>null);
    }

    /**
     * @param path (optional) 
     * @param lang (optional) 
     * @return Success
     */
    content(path?: string | null | undefined, lang?: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/content?";
        if (path !== undefined && path !== null)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContent(_response);
        });
    }

    protected processContent(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }
}

export enum ContentType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class ContentTypeDto implements IContentTypeDto {
    id?: number;
    code?: string | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;

    constructor(data?: IContentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
        }
    }

    static fromJS(data: any): ContentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        return data; 
    }

    clone(): ContentTypeDto {
        const json = this.toJSON();
        let result = new ContentTypeDto();
        result.init(json);
        return result;
    }
}

export interface IContentTypeDto {
    id?: number;
    code?: string | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
}

export class GetContentByCodeResponse implements IGetContentByCodeResponse {
    id?: number;
    code?: string | undefined;
    type?: ContentType;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    descriptionPrimaryLang?: string | undefined;
    descriptionSecondaryLang?: string | undefined;
    isPublished?: boolean;
    contentPrimaryLang?: string | undefined;
    contentSecondaryLang?: string | undefined;
    contentType?: ContentTypeDto;

    constructor(data?: IGetContentByCodeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.type = _data["type"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
            this.descriptionPrimaryLang = _data["descriptionPrimaryLang"];
            this.descriptionSecondaryLang = _data["descriptionSecondaryLang"];
            this.isPublished = _data["isPublished"];
            this.contentPrimaryLang = _data["contentPrimaryLang"];
            this.contentSecondaryLang = _data["contentSecondaryLang"];
            this.contentType = _data["contentType"] ? ContentTypeDto.fromJS(_data["contentType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetContentByCodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetContentByCodeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["type"] = this.type;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        data["descriptionPrimaryLang"] = this.descriptionPrimaryLang;
        data["descriptionSecondaryLang"] = this.descriptionSecondaryLang;
        data["isPublished"] = this.isPublished;
        data["contentPrimaryLang"] = this.contentPrimaryLang;
        data["contentSecondaryLang"] = this.contentSecondaryLang;
        data["contentType"] = this.contentType ? this.contentType.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetContentByCodeResponse {
        const json = this.toJSON();
        let result = new GetContentByCodeResponse();
        result.init(json);
        return result;
    }
}

export interface IGetContentByCodeResponse {
    id?: number;
    code?: string | undefined;
    type?: ContentType;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    descriptionPrimaryLang?: string | undefined;
    descriptionSecondaryLang?: string | undefined;
    isPublished?: boolean;
    contentPrimaryLang?: string | undefined;
    contentSecondaryLang?: string | undefined;
    contentType?: ContentTypeDto;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}